import { QaScoreButton, QaScoreButtonProps } from "./QaScoreButton";
import styles from "./QaScore.module.scss";

type ScoreItem = Omit<
  QaScoreButtonProps,
  "updateTicketScore" | "active" | "viewOnly" | "variant"
>;

const scoreItems: ScoreItem[] = [
  {
    value: 1,
    hint: "Not achieved",
    hintAlign: "left",
  },
  {
    value: 2,
  },
  {
    value: 3,
    hint: "Partly achieved",
  },
  {
    value: 4,
  },
  {
    value: 5,
    hint: "Achieved",
    hintAlign: "right",
  },
  {
    value: -1,
    label: "N/A",
  },
];

interface QaScoreResultNumericProps {
  value: number;
  updateScore: (newScore: number) => Promise<void>;
  viewOnly?: boolean;
}

export function QaScoreResultNumeric({
  value,
  updateScore,
  viewOnly = false,
}: QaScoreResultNumericProps) {
  return (
    <div className={styles.QaScoreResult}>
      {scoreItems.map((item) => (
        <QaScoreButton
          key={item.value}
          {...item}
          active={value === item.value}
          updateScore={updateScore}
          viewOnly={viewOnly}
        />
      ))}
    </div>
  );
}
